import { withRouter } from "react-router-dom";

import { RefreshView as Refresh } from "./refresh-view";

const RefreshView = withRouter(Refresh);

export { RefreshView };
